"use client"

const TokenSelector = ({
  selectToken,
  setSelectToken,
  tokenSelectionContext,
  tokenSearchKeyword,
  setTokenSearchKeyword,
  getFilteredTokens,
  selectTokenClick,
  tokenSellSelected,
  tokenBuySelected,
}) => {
  if (!selectToken) return null

  return (
    <div className={`rango-select-widget ${selectToken ? "show" : ""}`}>
      <div className="rango-selected-widget">
        <div className="rango-flex rango-flex--between">
          <div className="rango-icon" onClick={() => setSelectToken(false)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m12 19l-7-7l7-7m7 7H5"
              />
            </svg>
          </div>
          <div className="rango-title">Select {tokenSelectionContext === "sell" ? "Source" : "Destination"} Token</div>
          <div />
        </div>
        <div className="rango-input--icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
              <path d="m21 21l-4.34-4.34" />
              <circle cx="11" cy="11" r="8" />
            </g>
          </svg>
          <input
            onChange={(event) => setTokenSearchKeyword(event.target.value.trim())}
            type="text"
            className="rango-select--item"
            placeholder="Search by token name"
          />
        </div>
        <div className="rango-connect--options signle-item">
          {getFilteredTokens()
            .filter((token) => {
              if (tokenSearchKeyword === "") return true
              return token.symbol.toUpperCase().startsWith(tokenSearchKeyword.toUpperCase())
            })
            .map((token, index) => (
              <button
                key={index}
                onClick={() => selectTokenClick(token)}
                className={`rango-option--item ${token.symbol === (tokenSelectionContext === "sell" ? tokenSellSelected.symbol : tokenBuySelected.symbol) ? "active" : ""}`}
              >
                <img alt={token.symbol} src={token.image || "/placeholder.svg"} />
                <div>
                  <div className="text">{token.symbol}</div>
                </div>
              </button>
            ))}
        </div>
      </div>
    </div>
  )
}

export default TokenSelector
